import { fetchOfferLocationBreadcrumbs } from 'actions/OfferActions'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { useEffect, useMemo } from 'react'

export interface BreadcrumbProperty {
  propertyId: string
  type: 'le' | 'bedbank'
}

export function useOfferLocationBreadcrumbs(propertyId: string, type: 'le' | 'bedbank', showAllLocations: boolean) {
  return useOfferLocationsBreadcrumbs([{ propertyId, type }], showAllLocations)[0] ?? []
}

export function useOfferLocationsBreadcrumbs(properties: Array<BreadcrumbProperty>, showAllLocations: boolean): Array<App.LocationBreadcrumbs> {
  const dispatch = useAppDispatch()
  const breadcrumbsDict = useAppSelector(state => state.offer.locationBreadcrumbs)
  const breadcrumbs: Array<App.LocationBreadcrumbs> = useMemo<Array<App.LocationBreadcrumbs>>(() => properties.map(property => breadcrumbsDict[property.propertyId] ?? { locations: [] }), [breadcrumbsDict, properties])
  useEffect(() => {
    for (const property of properties) {
      dispatch(fetchOfferLocationBreadcrumbs(property.propertyId, property.type, showAllLocations))
    }
  }, [properties, showAllLocations, dispatch])
  return breadcrumbs
}
